import { render, staticRenderFns } from "./GiveToChannel.vue?vue&type=template&id=96c22a86&"
import script from "./GiveToChannel.vue?vue&type=script&lang=js&"
export * from "./GiveToChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports